/* @flow */

import { pptmFactory } from './pptm-factory';

export const pptm = pptmFactory();



// WEBPACK FOOTER //
// webpack://paypal/src/external/pptm.js